import React, { useEffect, useRef, useState } from 'react';

import { useCheck, useCheckMeta, usePageMessages } from 'apps/auth/hooks/selectors';

import CheckButtons from './units/CheckButtons';
import CheckHeader from './units/CheckHeader';
import DateTransferIdUnit from './units/DateTransferIdUnit';
import FeeRateUnit from './units/FeeRateUnit';
import PaymentNumber from './units/PaymentNumber';
import RecipientDetails from './units/RecipientDetails';

const HistoryCheque = (props) => {
    const { cancelTransactionInfoSeconds, cancelTransactionInfoMinutes } = usePageMessages();
    const { canCancelTransaction } = useCheckMeta();
    const { secondsTillCancel, errorCode } = useCheck();
    const cheque = useCheck();

    const [cancelTimer, updateCancelTimer] = useState(parseInt(secondsTillCancel));
    const [isCancelTransaction, setIsCancelTransaction] = useState(canCancelTransaction);
    const [timerUnit, setTimeUnit] = useState(parseInt(secondsTillCancel) >= 60 ? cancelTransactionInfoMinutes : cancelTransactionInfoSeconds);

    const intervalId = useInterval(() => {
        if (isCancelTransaction && cancelTimer > 0) {
            updateCancelTimer(cancelTimer - 1);
            setTimeUnit(cancelTimer >= 60 ? cancelTransactionInfoMinutes : cancelTransactionInfoSeconds);
        } else {
            setIsCancelTransaction(false);
            clearInterval(intervalId);
        }
    }, 1000);

    return (
        <>
            <CheckHeader canCancelTransaction={isCancelTransaction} timerUnit={timerUnit} cancelTimer={cancelTimer} setModal={props.setModal} />
            <CheckButtons canCancelTransaction={true} serverError={errorCode} />
            <DateTransferIdUnit getFormattedChequeDate={props.getFormattedChequeDate} />
            <FeeRateUnit />
            <RecipientDetails cheque={cheque} />
            {cheque && cheque.accountFrom && <PaymentNumber />}
        </>
    );
};

const useInterval = (callback, delay) => {
    let id;
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        let id = setInterval(() => {
            savedCallback.current();
        }, delay);

        return () => clearInterval(id);
    }, [delay]);
    return id;
};

export default HistoryCheque;
